import { createDomain } from 'effector-root';

const domain = createDomain('Customers (Page)');

export const onPageStarted = domain.event();